import { MagazineContextProvider } from '@/contexts/Magazine/Magazine.context';
import Icon from '@uikit/components/Icon/Icon';
import LegacyPicture from '@uikit/components/LegacyPicture/LegacyPicture';
import Link from '@uikit/components/Link/Link';
import styles from './MagazineCategoryTeaser.module.scss';
import type { MagazineCategoryTeaserProps } from './interfaces';

const MagazineCategoryTeaser = ({
  title,
  text,
  linkintern,
  image,
  category,
}: MagazineCategoryTeaserProps) => {
  return (
    <Link to={linkintern} className={styles.base}>
      <MagazineContextProvider value={{ currentCategory: category }}>
        <div className={styles.wrapper}>
          <div className={styles.content}>
            <div className={styles.title}>{title}</div>
            <div className={styles.text}>{text}</div>
            <Icon variant={'action/arrow-right'} size={'iconSize24'} />
          </div>
          <div className={styles.backgroundImage}>
            <div className={styles.imageWrapper}>
              <LegacyPicture asset={image} />
            </div>
          </div>
        </div>
      </MagazineContextProvider>
    </Link>
  );
};

export default MagazineCategoryTeaser;
